__turbopack_context__.v({
  "checkbox": "CheckboxGroup-module__XLEq2W__checkbox",
  "checkboxGroup": "CheckboxGroup-module__XLEq2W__checkboxGroup",
  "options": "CheckboxGroup-module__XLEq2W__options",
});
